import React, { useState, useEffect } from 'react'


const NavbarComponent = () => {
    const [isIconClicked, setIsIconClicked] = useState(false);
              
    const handleClick = () => {
      setIsIconClicked(true);
    };
    useEffect(() => {
        const handleClickOutside = () => {
          setIsIconClicked(false);
        };
    
        document.addEventListener('click', handleClickOutside);
    
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, []);
  return (
        <div className="nav__menu">
            <ul className="nav__list">
                <li className={`nav__item ${isIconClicked ? 'icon-clicked' : ''}`}>
                  <a href="#home" className="nav__link" onClick={handleClick}>
                    <i className="fi fi-sr-home"></i>
                    <span>Home</span>
                   </a>
                </li>
                <li className={`nav__item ${isIconClicked ? 'icon-clicked' : ''}`}>
                  <a href="#projects" className="nav__link" onClick={handleClick}>
                    <i className="fi fi-sr-star"></i>
                    <span>Projects</span>
                   </a>
                 </li>
                <li className={`nav__item ${isIconClicked ? 'icon-clicked' : ''}`}>
                  <a href="#skills" className="nav__link" onClick={handleClick}>
                    <i className="fi fi-sr-book-open-cover"></i>
                    <span>Skills</span>
                   </a>
                 </li>
                 <li className={`nav__item ${isIconClicked ? 'icon-clicked' : ''}`}>
                  <a href="#services" className="nav__link" onClick={handleClick}>
                    <i className="fi fi-sr-briefcase"></i>
                    <span>Job</span>
                   </a>
                 </li>
                 <li className={`nav__item ${isIconClicked ? 'icon-clicked' : ''}`}>
                  <a href="#contact" className="nav__link" onClick={handleClick}>
                    <i className="fi fi-sr-comment-alt"></i>
                    <span>Contact</span>
                   </a>
                 </li>
            </ul>
        </div>
  )
}

export default NavbarComponent